import { AxiosError } from 'axios';

const RELOAD_STORAGE_KEY = 'apiUnreachableReloadAt';
const RELOAD_INTERVAL_MS = 10 * 60 * 1000;

/**
 * Reloads the page when a request to our API got no response at all while the browser is online. That is what a tab
 * still running an old build sees after the API moved to another domain: only a reload loads the build with the new
 * one. Reloads at most once per 10 minutes per tab, so an API outage can't cause a reload loop. Timeouts don't count.
 * @returns `true` when it triggered a reload
 */
export const reloadIfApiUnreachable = (error: AxiosError): boolean => {
    if (error.code !== AxiosError.ERR_NETWORK || !navigator.onLine) {
        return false;
    }

    const lastReloadAt = Number(sessionStorage.getItem(RELOAD_STORAGE_KEY));
    if (Date.now() - lastReloadAt < RELOAD_INTERVAL_MS) {
        return false;
    }
    sessionStorage.setItem(RELOAD_STORAGE_KEY, String(Date.now()));

    window.location.reload();
    return true;
};
